import { Component, OnDestroy, OnInit } from '@angular/core';
import HC_stock from 'highcharts/modules/stock';
import { interval, Subscription } from 'rxjs';
import { MetalPriceService } from 'src/app/services/metal-price.service';
import SunsetTheme from 'highcharts/themes/sunset.js';
import * as Highcharts from 'highcharts';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HighchartsChartModule } from 'highcharts-angular';

if (typeof HC_stock === 'function') {
  HC_stock(Highcharts);
}

Highcharts.setOptions({
  title: {
    style: {
      color: 'tomato',
    },
  },
  legend: {
    enabled: false,
  },
});

if (typeof SunsetTheme === 'function') {
  SunsetTheme(Highcharts);
}

console.log('SONO QUI');

@Component({
  selector: 'app-lazy-loading-chart-component',
  templateUrl: './lazy-loading-chart-component.component.html',
  styleUrls: ['./lazy-loading-chart-component.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HighchartsChartModule
  ],
  providers: [MetalPriceService]
})
export class LazyLoadingChartComponentComponent implements OnInit, OnDestroy {

  Highcharts: typeof Highcharts = Highcharts;
  chartRef: Highcharts.Chart | undefined;
  chartCallback: Highcharts.ChartCallbackFunction = chart => {
    this.chartRef = chart;
  };


  metal: string = 'AUX';
  currency: string = 'EUR';
  interval: string = '15';
  chartType: string = 'area';
  screenWidth: number = window.innerWidth;

  goldPrice: string = '';
  lastUpdated: string = '';

  private liveUpdateSubscription: Subscription | null = null;
  isLiveUpdateEnabled: boolean = true;
  isDataUpdating: boolean = false;
  liveUpdateInterval: number = 30000;

  timeframes = [
    // { id: '5', label: '10min', title: '10 minuti', intervalMs: 1 * 60 * 1000, isIntraday: true },
    {
      id: '15',
      label: '1h',
      title: '1 ora',
      selected: true,
      intervalMs: 5 * 60 * 1000,
      isIntraday: true,
    },
    { id: '120', label: '6h', title: '6 ore', intervalMs: 15 * 60 * 1000, isIntraday: true },
    { id: '600', label: '1g', title: '1 giorno', intervalMs: 30 * 60 * 1000, isIntraday: true },
    // {
    //   id: '3600',
    //   label: '1sett',
    //   title: '1 settimana',
    //   intervalMs: 6 * 60 * 60 * 1000,
    //   isIntraday: false,
    // },
    {
      id: '14400',
      label: '1m',
      title: '1 mese',
      intervalMs: 24 * 60 * 60 * 1000,
      isIntraday: false,
    },
    {
      id: '43200',
      label: '3m',
      title: '3 mesi',
      intervalMs: 3 * 24 * 60 * 60 * 1000,
      isIntraday: false,
    },
    {
      id: '172800',
      label: '1a',
      title: '1 anno',
      intervalMs: 7 * 24 * 60 * 60 * 1000,
      isIntraday: false,
    },
    {
      id: '864000',
      label: '5a',
      title: '5 anni',
      intervalMs: 30 * 24 * 60 * 60 * 1000,
      isIntraday: false,
    },
    {
      id: '2592000',
      label: '20a',
      title: '20 anni',
      intervalMs: 90 * 24 * 60 * 60 * 1000,
      isIntraday: false,
    },
  ];

  get currentTimeframe(): any {
    return this.timeframes.find(tf => tf.id === this.interval) || this.timeframes[1];
  }

  get isIntraday(): boolean {
    return this.currentTimeframe.isIntraday;
  }

  get currentIntervalMs(): number {
    const timeframe = this.timeframes.find(tf => tf.id === this.interval);
    return timeframe ? timeframe.intervalMs : 5 * 60 * 1000;
  }

  chartOptions: Highcharts.Options = {
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            chart: {
              spacing: [0, 0, 0, 0],
            },
            legend: {
              enabled: false,
            },
            yAxis: {
              title: {
                text: null,
              },
            },
          },
        },
      ],
    },
    chart: {
      // events: {
      //   load: function () {
      //     const xOffset = window.innerWidth <= 480 ? -120 : -160;
      //     const marker = this.renderer.image(
      //       './assets/images/GoldLogoGold.png',
      //       window.innerWidth / 2 + xOffset,
      //       20,
      //       277,
      //       90
      //     );
      //     marker.add();
      //   },
      // },
      animation: {
        duration: 800,
        easing: 'easeOutQuart',
      },
      //backgroundColor: 'rgba(51, 31, 4, 1)',
      backgroundColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      spacing: [20, 20, 20, 20],
      resetZoomButton: {
        position: {
          x: -10,
          y: 10,
        },
        theme: {
          fill: '#8B6914',
          stroke: '#5E4A14',
          r: 4,
          states: {
            hover: {
              fill: '#AD9965',
              style: {
                color: 'white',
              },
            },
          },
        },
      },
      style: {
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      },
    },
    rangeSelector: {
      enabled: false,
    },
    loading: {
      style: {
        backgroundColor: '#302507',
        opacity: 0.8,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
      },
      labelStyle: {
        color: '#F0DBA5',
        fontWeight: 'bold',
      },
      showDuration: 250,
      hideDuration: 500,
    },
    navigator: {
      enabled: true,
      height: 40,
      margin: 20,
      outlineColor: '#8B6914',
      outlineWidth: 0,
      maskFill: 'rgba(173,153,101,0.25)',
      handles: {
        backgroundColor: '#8B6914',
        borderColor: '#F0DBA5',
      },
      series: {
        color: '#835F08',
        lineColor: '#AD9965',
        lineWidth: 2,
        fillOpacity: 0.3,
      },
      xAxis: {
        gridLineColor: 'rgba(242, 242, 242, 0)',
        labels: {
          style: {
            color: '#835F08',
            fontSize: '11px',
            fontWeight: '500',
          },
          y: 16,
          format: '{value:%H:%M}',
        },
      },
    },
    scrollbar: {
      enabled: true,
      barBackgroundColor: '#8B6914',
      barBorderColor: '#9C7A3C',
      barBorderRadius: 4,
      barBorderWidth: 0,
      buttonBackgroundColor: '#8B6914',
      buttonBorderColor: '#9C7A3C',
      buttonArrowColor: '#F0DBA5',
      buttonBorderRadius: 4,
      rifleColor: '#F0DBA5',
      trackBackgroundColor: '#5E4A14',
      trackBorderColor: '#9C7A3C',
      trackBorderRadius: 4,
      height: 8,
      margin: 10,
    },
    xAxis: {
      type: 'datetime',
      lineColor: 'rgba(242, 242, 242, 0)',
      gridLineColor: 'rgba(242, 242, 242, 0)',
      labels: {
        format: '{value:%H:%M}',
        style: {
          color: '#835F08',
          fontSize: '12px',
          fontWeight: '500',
        },
        y: 12,
        distance: 8,
      },
      tickLength: 5,
      tickPosition: 'inside',
      tickColor: 'rgba(173, 153, 101, 0.3)',
      crosshair: {
        color: '#835F08',
        width: 1,
        dashStyle: 'Dash',
        label: {
          enabled: true,
          backgroundColor: '#5E4A14',
          borderColor: '#8B6914',
          borderWidth: 0,
          borderRadius: 4,
          padding: 6,
          style: {
            color: '#F0DBA5',
          },
        },
      },
    },
    yAxis: {
      title: {
        text: this.currency + ' / Kg',
        style: {
          color: '#835F08',
          fontSize: '13px',
          fontWeight: '500',
        },
      },
      opposite: false,
      gridLineColor: 'rgba(173, 153, 101, 0.1)',
      gridLineWidth: 1,
      gridLineDashStyle: 'Dot',
      lineColor: 'rgba(242, 242, 242, 0)',
      labels: {
        align: 'right',
        x: -8,
        style: {
          color: '#835F08',
          fontSize: '12px',
          fontWeight: '500',
        },
        formatter: function () {
          return this.value.toLocaleString('it-IT');
        },
      },
      crosshair: {
        color: '#835F08',
        width: 1,
        dashStyle: 'Dash',
        label: {
          enabled: true,
          backgroundColor: '#5E4A14',
          borderColor: '#8B6914',
          borderWidth: 0,
          borderRadius: 4,
          padding: 6,
          style: {
            color: '#F0DBA5',
          },
        },
      },
    },
    colors: [
      '#AD9965',
      '#F23645',
      '#089981',
      '#9C7A3C',
      '#D6B066',
      '#80699B',
      '#3D96AE',
      '#DB843D',
    ],
    tooltip: {
      backgroundColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1,
        },
        stops: [
          [0, '#5E4A14'],
          [1, '#302507'],
        ],
      },
      borderColor: '#8B6914',
      borderWidth: 0,
      borderRadius: 4,
      shadow: {
        offsetX: 0,
        offsetY: 2,
        width: 6,
        color: 'rgba(0,0,0,0.3)',
      },
      style: {
        color: '#835F08',
        fontSize: '13px',
        fontWeight: '400',
        padding: '8px',
      },
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e. %b',
        week: '%e. %b',
        month: "%b '%y",
        year: '%Y',
      },
      shared: true,
      split: false,
      valueDecimals: 2,
      valuePrefix: '',
      xDateFormat: '%A, %e %b %Y, %H:%M',
      headerFormat: '<span style="font-size: 11px; font-weight: 600;">{point.key}</span><br/>',
      pointFormat: '<span style="color:{point.color}">●</span> <b>{point.y:,.2f}</b><br/>',
    },
    legend: {
      enabled: false,
      itemStyle: {
        color: '#F0DBA5',
        fontSize: '12px',
        fontWeight: '500',
      },
      itemHoverStyle: {
        color: '#FFFFFF',
      },
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1200,
          easing: 'easeOutQuart',
        },
        lineWidth: 2,
        marker: {
          enabled: false,
          radius: 3,
          lineWidth: 1,
          lineColor: '#5E4A14',
          symbol: 'circle',
          states: {
            hover: {
              enabled: true,
              lineColor: '#AD9965',
              lineWidth: 2,
              radius: 5,
            },
          },
        },
        shadow: false,
        states: {
          hover: {
            lineWidth: 3,
            halo: {
              size: 10,
              opacity: 0.25,
            },
          },
        },
        threshold: null,
        turboThreshold: 0,
        dataLabels: {
          enabled: false,
        },
      },
      area: {
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, 'rgba(173,153,101,0.8)'],
            [1, 'rgba(111, 101, 173, 0.1)'],
          ],
        },
        lineColor: '#AD9965',
        lineWidth: 2,
      },
    },
    series: [
      {
        type: 'area',
        id: 'base',
        name: this.currency,
        data: [[0, 0]],
        tooltip: {
          valueDecimals: 2,
        },
        fillOpacity: 0.5,
      },
      {
        type: 'area',
        showInLegend: true,
        linkedTo: 'base',
      },
    ] as Highcharts.SeriesOptionsType[],
  };

  constructor(private metalPriceService: MetalPriceService) {
  }

  ngOnInit(): void {
    document.body.className = '';
    document.body.classList.add('night_view');
    document.documentElement.style.setProperty('background-color', 'rgba(51, 31, 4, 1)');

    Highcharts.setOptions({
      time: {
        timezone: 'Europe/Rome',
        timezoneOffset: -1 * 60,
      },
      lang: {
        locale: 'it-IT',
        thousandsSep: '.',
        decimalPoint: ',',
        months: [
          'Gennaio',
          'Febbraio',
          'Marzo',
          'Aprile',
          'Maggio',
          'Giugno',
          'Luglio',
          'Agosto',
          'Settembre',
          'Ottobre',
          'Novembre',
          'Dicembre',
        ],
        shortMonths: [
          'Gen',
          'Feb',
          'Mar',
          'Apr',
          'Mag',
          'Giu',
          'Lug',
          'Ago',
          'Set',
          'Ott',
          'Nov',
          'Dic',
        ],
        weekdays: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
        shortWeekdays: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
        loading: 'Caricamento...',
      },
    });

    this.updateChart(this.metal, this.currency, this.interval, this.chartType);

    this.setupLiveUpdates();
  }

  ngOnDestroy(): void {
    this.stopLiveUpdates();
  }

  setupLiveUpdates(): void {
    this.stopLiveUpdates();

    if (this.isIntraday) {
      this.startLiveUpdates();
    } else {
      this.isLiveUpdateEnabled = false;
    }
  }

  startLiveUpdates(): void {
    this.isLiveUpdateEnabled = true;
    this.liveUpdateSubscription = interval(this.liveUpdateInterval).subscribe(() => {
      this.fetchLiveData();
    });
  }

  stopLiveUpdates(): void {
    if (this.liveUpdateSubscription) {
      this.liveUpdateSubscription.unsubscribe();
      this.liveUpdateSubscription = null;
    }
  }

  toggleLiveUpdates(): void {
    if (!this.isIntraday) {
      this.isLiveUpdateEnabled = false;
      return;
    }

    if (this.isLiveUpdateEnabled) {
      this.stopLiveUpdates();
      this.isLiveUpdateEnabled = false;
    } else {
      this.startLiveUpdates();
    }
  }

  formatDateTime(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  }

  formatPrice(price: number): string {
    return price.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  updatePriceDisplay(newPrice: number, oldPrice: number = 0): void {
    this.goldPrice = this.formatPrice(newPrice);

    setTimeout(() => {
      const priceElement = document.querySelector('.gold-price');
      if (priceElement) {
        priceElement.classList.remove('price-up', 'price-down');

        if (newPrice > oldPrice) {
          priceElement.classList.add('price-up');
        } else if (newPrice < oldPrice) {
          priceElement.classList.add('price-down');
        }
      }
    }, 0);
  }

  processChartData(data: any): [number, number][] {
    const chartData: [number, number][] = [];

    if (data && data.seriesData && data.seriesData.prices) {
      const priceData = [...data.seriesData.prices].reverse();

      priceData.forEach((val: any) => {
        if (val.latestPrice !== null) {
          chartData.push([val.priceTime, val.latestPrice]);
        }
      });
    }

    return chartData;
  }

  updateChartWithData(chartData: [number, number][], data: any): void {
    if (!this.chartRef || chartData.length === 0) {
      return;
    }

    const startTime = data.seriesData.prices[data.seriesData.prices.length - 1].priceTime;
    const endTime = data.seriesData.prices[0].priceTime;

    const series = this.chartRef.series[0];
    series.setData(chartData, true, { duration: 1000 });

    this.chartRef.xAxis[0].setExtremes(startTime, endTime);
  }

  fetchLiveData(): void {
    if (!this.isIntraday || this.isDataUpdating) {
      return;
    }

    this.isDataUpdating = true;

    const priceElement = document.querySelector('.gold-price');
    if (priceElement) {
      priceElement.classList.add('updating');
      setTimeout(() => {
        priceElement.classList.remove('updating');
      }, 1000);
    }

    this.metalPriceService.fetchData(this.metal, this.currency, this.interval).subscribe({
      next: (data: any) => {
        const chartData = this.processChartData(data);

        if (data.latestPrice && data.latestPrice.price) {
          const oldPrice = parseFloat(this.goldPrice.replace(/,/g, ''));
          const newPrice = data.latestPrice.price;

          this.updatePriceDisplay(newPrice, oldPrice);

          if (data.latestPrice.timestamp) {
            this.lastUpdated = this.formatDateTime(data.latestPrice.timestamp);
          }
        }

        if (this.chartRef && chartData.length > 0) {
          this.updateChartWithData(chartData, data);

          this.flashChartUpdate();
        }

        this.isDataUpdating = false;
      },
      error: error => {
        console.error('Error fetching live data:', error);
        this.isDataUpdating = false;
      },
    });
  }

  flashChartUpdate(): void {
    if (!this.chartRef) {
      return;
    }

    const chart = this.chartRef;

    const overlay = chart.renderer
      .rect(chart.plotLeft, chart.plotTop, chart.plotWidth, chart.plotHeight, 0)
      .attr({
        fill: 'rgba(173, 153, 101, 0.1)',
        zIndex: 999,
      })
      .add();

    setTimeout(() => {
      overlay.animate(
        {
          opacity: 0,
        },
        {
          duration: 500,
        },
        function () {
          overlay.destroy();
        }
      );
    }, 100);
  }

  updateLivePrices(): void {
    const oldPrice = this.goldPrice ? parseFloat(this.goldPrice.replace(/[^\d.-]/g, '')) : 0;

    this.metalPriceService.fetchData('AUX', this.currency, this.interval).subscribe({
      next: (data: any) => {
        if (data && data.latestPrice) {
          const newPrice = data.latestPrice.price;

          this.updatePriceDisplay(newPrice, oldPrice);

          if (data.latestPrice.timestamp) {
            this.lastUpdated = this.formatDateTime(data.latestPrice.timestamp);
          }
        }
      },
      error: error => console.error('Error fetching gold price:', error),
    });
  }

  updateChart(metal: string, currency: string, interval: string, chartType: string): void {
    if (this.chartRef) {
      this.chartRef.showLoading();
    }

    this.setupLiveUpdates();

    const oldPrice = this.goldPrice ? parseFloat(this.goldPrice.replace(/[^\d.-]/g, '')) : 0;

    this.metalPriceService.fetchData(metal, currency, interval).subscribe({
      next: (data: any) => {
        const chartData = this.processChartData(data);

        if (this.chartRef && chartData.length > 0) {
          this.chartRef.yAxis[0].setTitle({
            text: currency + ' / Kg',
            style: {
              color: '#835F08',
              fontSize: '12px',
            },
          });

          this.chartRef.series[0].update({
            name: currency,
            data: chartData,
            type: chartType as any,
            pointInterval: this.currentIntervalMs,
            color: '#AD9965',
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, 'rgba(173,153,101,0.8)'],
                [1, 'rgba(173,153,101,0.2)'],
              ],
            },
            tooltip: {
              valueDecimals: 2,
            },
          });

          this.updateTimeFormat(interval);

          if (data.latestPrice && data.latestPrice.price) {
            const newPrice = data.latestPrice.price;

            this.updatePriceDisplay(newPrice, oldPrice);

            if (data.latestPrice.timestamp) {
              this.lastUpdated = this.formatDateTime(data.latestPrice.timestamp);
            }
          }

          const startTime = data.seriesData.prices[data.seriesData.prices.length - 1].priceTime;
          const endTime = data.seriesData.prices[0].priceTime;
          this.chartRef.xAxis[0].setExtremes(startTime, endTime);

          this.chartRef.hideLoading();
        }
      },
      error: error => {
        console.error('Error fetching data:', error);
        if (this.chartRef) {
          this.chartRef.hideLoading();
        }
      },
    });
  }

  updateTimeFormat(interval: string): void {
    const timeframeId = parseInt(interval);
    let format = '{value:%H:%M}';
    let tooltipFormat: any = {};

    if (timeframeId >= 2592000) {
      format = '{value:%Y}';
      tooltipFormat = {
        millisecond: '%A, %e %b %Y',
        second: '%A, %e %b %Y',
        minute: '%A, %e %b %Y',
        hour: '%A, %e %b %Y',
        day: '%A, %e %b %Y',
        week: '%A, %e %b %Y',
        month: '%b %Y',
        year: '%Y',
      };
    } else if (timeframeId >= 864000) {
      format = '{value:%b %Y}';
      tooltipFormat = {
        millisecond: '%A, %e %b %Y',
        second: '%A, %e %b %Y',
        minute: '%A, %e %b %Y',
        hour: '%A, %e %b %Y',
        day: '%A, %e %b %Y',
        week: '%A, %e %b %Y',
        month: '%b %Y',
        year: '%Y',
      };
    } else if (timeframeId >= 172800) {
      format = '{value:%b %Y}';
      tooltipFormat = {
        millisecond: '%A, %e %b %Y',
        second: '%A, %e %b %Y',
        minute: '%A, %e %b %Y',
        hour: '%A, %e %b %Y',
        day: '%A, %e %b %Y',
        week: '%A, %e %b %Y',
        month: '%b %Y',
        year: '%Y',
      };
    } else if (timeframeId !== 0) {
      format = '{value:%e %b}';
      tooltipFormat = {
        millisecond: '%A, %e %b %Y',
        second: '%A, %e %b %Y',
        minute: '%A, %e %b %Y',
        hour: '%A, %e %b %Y',
        day: '%A, %e %b',
        week: '%A, %e %b',
        month: '%b %Y',
        year: '%Y',
      };
    } else if (timeframeId >= 14400) {
      format = '{value:%e %b}';
      tooltipFormat = {
        millisecond: '%A, %e %b, %H:%M:%S.%L',
        second: '%A, %e %b, %H:%M:%S',
        minute: '%A, %e %b, %H:%M',
        hour: '%A, %e %b, %H:%M',
        day: '%A, %e %b',
        week: '%A, %e %b',
        month: '%b %Y',
        year: '%Y',
      };
    } else if (timeframeId >= 3600) {
      format = '{value:%e %b}';
      tooltipFormat = {
        millisecond: '%A, %e %b, %H:%M:%S.%L',
        second: '%A, %e %b, %H:%M:%S',
        minute: '%A, %e %b, %H:%M',
        hour: '%A, %e %b, %H:%M',
        day: '%A, %e %b',
        week: '%A, %e %b',
        month: '%b %Y',
        year: '%Y',
      };
    } else if (timeframeId >= 600) {
      format = '{value:%H:%M}';
      tooltipFormat = {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%A, %e %b, %H:%M',
        week: '%A, %e %b',
        month: '%b %Y',
        year: '%Y',
      };
    } else if (timeframeId >= 120) {
      format = '{value:%H:%M}';
      tooltipFormat = {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%A, %e %b',
        week: '%A, %e %b',
        month: '%b %Y',
        year: '%Y',
      };
    } else {
      format = '{value:%H:%M}';
      tooltipFormat = {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%A, %e %b',
        week: '%A, %e %b',
        month: '%b %Y',
        year: '%Y',
      };
    }

    if (this.chartRef) {
      this.chartRef.xAxis[0].update({
        labels: {
          format: format,
          style: {
            color: '#835F08',
            fontSize: '12px',
            fontWeight: '500',
          },
          distance: 8,
          y: 12,
        },
        tickInterval: this.currentIntervalMs,
        tickLength: 5,
        tickPosition: 'inside',
        tickColor: 'rgba(79, 46, 145, 0.3)',
        crosshair: {
          color: '#D6B066',
          width: 1,
          dashStyle: 'Dash',
          label: {
            enabled: true,
            backgroundColor: '#5E4A14',
            borderColor: '#8B6914',
            borderRadius: 4,
            padding: 6,
            style: {
              color: '#F0DBA5',
            },
          },
        },
      });

      this.chartRef.update(
        {
          tooltip: {
            dateTimeLabelFormats: tooltipFormat,
            shared: true,
            split: false,
            backgroundColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1,
              },
              stops: [
                [0, '#5E4A14'],
                [1, '#302507'],
              ],
            },
            style: {
              color: '#F0DBA5',
              fontSize: '13px',
              fontWeight: '400',
            },
            borderRadius: 4,
            shadow: {
              offsetX: 0,
              offsetY: 2,
              width: 6,
              color: 'rgba(0,0,0,0.3)',
            },
          },
        },
        false
      );

      this.chartRef.redraw();
    }
  }

  onCurrencyChange(): void {
    this.updateChart(this.metal, this.currency, this.interval, this.chartType);
  }

  onChartTypeChange(): void {
    this.updateChart(this.metal, this.currency, this.interval, this.chartType);
  }

  onTimeframeSelect(interval: string): void {
    this.interval = interval;
    this.updateChart(this.metal, this.currency, this.interval, this.chartType);
  }


}
